import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const ContactsFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
      <g id="picto" transform="translate(-668 -150)">
        <circle id="bg" cx="35" cy="35" r="35" transform="translate(668 150)" fill="#2980b9"/>
        <g id="Groupe_32" data-name="Groupe 32" transform="translate(674.021 155.266)">
          <path id="Tracé_475" data-name="Tracé 475" d="M29.864,25.824V22.216A7.216,7.216,0,0,0,22.648,15H8.216A7.216,7.216,0,0,0,1,22.216v3.608" transform="translate(8.135 20.4)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <circle id="Ellipse_354" data-name="Ellipse 354" cx="7.392" cy="7.392" r="7.392" transform="translate(15.958 13.244)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <path id="Tracé_476" data-name="Tracé 476" d="M25.412,25.719V22.111A7.216,7.216,0,0,0,20,15.13" transform="translate(23.411 20.504)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <path id="Tracé_477" data-name="Tracé 477" d="M16,3.13a7.216,7.216,0,0,1,0,13.981" transform="translate(20.195 10.856)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default ContactsFilled;